import React from "react";
import {useTranslation} from "react-i18next";
import cn from "classnames";
import classes from "./ChallengeCustomizeForm.module.css";
import WithTooltip from "../../ui/tooltip";
import {AddIcon, HelpCircleIcon} from "../../ui/icons";
import Button from "../../ui/button";
import Link from "../../ui/link";

type ResultDescriptionsListProps<T extends {id: string}> = {
  labelKey: string;
  helpTextKey: string;
  descriptions: T[] | undefined;
  displayDescriptions: T[] | undefined;
  allVisible: boolean;
  onShowAll: () => void;
  onShowLess: () => void;
  onAdd: () => void;
  onUpdate: (e: React.MouseEvent) => void;
  formatDescription: (desc: T) => string;
  disabled?: boolean;
  buttonClassName?: string;
};

export function ResultDescriptionsList<T extends {id: string}>({
                                                          labelKey,
                                                          helpTextKey,
                                                          descriptions,
                                                          displayDescriptions,
                                                          allVisible,
                                                          onShowAll,
                                                          onShowLess,
                                                          onAdd,
                                                          onUpdate,
                                                          formatDescription,
                                                          disabled,
                                                          buttonClassName,
                                                        }: ResultDescriptionsListProps<T>) {
  const {t} = useTranslation();

  return (
    <div className={cn(classes.formItem)}>
      <label className={classes.label}>
        {t(labelKey)}{" "}
        <WithTooltip className={classes.help} as="span" helpText={t(helpTextKey)}>
          <HelpCircleIcon />
        </WithTooltip>
      </label>

      {displayDescriptions &&
      displayDescriptions.length > 0 &&
      displayDescriptions.map((desc) => (
        <Button
          className={cn(classes.listItem, buttonClassName)}
          onClick={onUpdate}
          key={desc.id}
          data-descid={desc.id}
          disabled={disabled}
        >
          {formatDescription(desc)}
        </Button>
      ))}
      {descriptions &&
      descriptions.length > 3 &&
      (allVisible ? (
        <Link className={classes.listItem} onClick={onShowLess}>
          {t("components.ChallengeCustomizeForm.parametricResultDescriptions.showLess")}
        </Link>
      ) : (
        <Link className={classes.listItem} onClick={onShowAll}>
          {t("components.ChallengeCustomizeForm.parametricResultDescriptions.showAll")}
        </Link>
      ))}

      <Button className={classes.listItem} onClick={onAdd} disabled={disabled}>
        <AddIcon />
        {t("common.add")}
      </Button>
    </div>
  );
}
